import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { ApolloLink, Observable } from 'apollo-link';
import { hasDirectives, getMainDefinition } from 'apollo-utilities';
import * as Async from 'graphql-anywhere/lib/async';
import { removeClientSetsFromDocument, capitalizeFirstLetter, extractResolversAndDependencies, addDependenciesToDocument, normalizeTypeDefs } from './utils';
var graphql = Async.graphql;

function createResolver(query, resolvers, defaults) {
  return function (fieldName) {
    var rootValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var args = arguments.length > 2 ? arguments[2] : undefined;
    var context = arguments.length > 3 ? arguments[3] : undefined;
    var info = arguments.length > 4 ? arguments[4] : undefined;
    var resultKey = info.resultKey;
    var type = capitalizeFirstLetter(getMainDefinition(query).operation) || 'Query';
    var aliasedNode = rootValue[resultKey];
    var preAliasingNode = rootValue[fieldName];
    var aliasNeeded = resultKey !== fieldName; // If aliasedValue is defined, some other link or serverQuery already returned a value

    if (aliasedNode !== undefined || preAliasingNode !== undefined) {
      return aliasedNode || preAliasingNode;
    } // Look for the field in the custom resolver map


    var resolverMap = resolvers[rootValue.__typename || type];

    if (resolverMap) {
      var resolve = resolverMap[fieldName];

      if (resolve) {
        return resolve(rootValue, args, context, info);
      }
    }

    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
  };
}

export function withClientState() {
  var clientStateConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    resolvers: {},
    defaults: {}
  };
  var resolversAndDeps = clientStateConfig.resolvers,
      defaults = clientStateConfig.defaults,
      cache = clientStateConfig.cache,
      typeDefs = clientStateConfig.typeDefs,
      fragmentMatcher = clientStateConfig.fragmentMatcher;

  if (cache && defaults) {
    cache.writeData({
      data: defaults
    });
  }

  var ComputedLink =
  /*#__PURE__*/
  function (_ApolloLink) {
    _inherits(ComputedLink, _ApolloLink);

    function ComputedLink() {
      _classCallCheck(this, ComputedLink);

      return _possibleConstructorReturn(this, _getPrototypeOf(ComputedLink).apply(this, arguments));
    }

    _createClass(ComputedLink, [{
      key: "writeDefaults",
      value: function writeDefaults() {
        if (cache && defaults) {
          cache.writeData({
            data: defaults
          });
        }
      }
    }, {
      key: "request",
      value: function request(operation, forward) {
        forward = forward != null ? forward : function () {
          return Observable.of({
            data: {}
          });
        };
        var query = operation.query;

        if (typeDefs) {
          var directives = 'directive @client on FIELD';
          var definition = normalizeTypeDefs(typeDefs);
          operation.setContext(function (_ref) {
            var _ref$schemas = _ref.schemas,
                schemas = _ref$schemas === void 0 ? [] : _ref$schemas;
            return {
              schemas: schemas.concat([{
                definition: definition,
                directives: directives
              }])
            };
          });
        }

        if (!hasDirectives(['client'], query)) {
          return forward(operation);
        }

        var _extractResolversAndD = extractResolversAndDependencies(resolversAndDeps),
            resolvers = _extractResolversAndD.resolvers,
            dependencies = _extractResolversAndD.dependencies;

        query = addDependenciesToDocument(query, dependencies);
        var serverQuery = removeClientSetsFromDocument(query);
        var resolver = createResolver(query, resolvers, defaults);

        if (serverQuery) {
          operation.query = serverQuery;
        }

        var obs = serverQuery && forward ? forward(operation) : Observable.of({
          data: {}
        });
        return new Observable(function (observer) {
          var _complete = false;
          var handlingNext = false;
          obs.subscribe({
            next: function next(_ref2) {
              var data = _ref2.data,
                  errors = _ref2.errors;
              var observerErrorHandler = observer.error.bind(observer);
              var context = operation.getContext();
              handlingNext = true; //data is from the server and provides the root value to this GraphQL resolution
              //when there is no resolver, the data is taken from the context

              graphql(resolver, query, data, context, operation.variables, {
                fragmentMatcher: fragmentMatcher
              }).then(function (nextData) {
                observer.next({
                  data: nextData,
                  errors: errors
                });

                if (_complete) {
                  observer.complete();
                }

                handlingNext = false;
              }).catch(observerErrorHandler);
            },
            error: observer.error.bind(observer),
            complete: function complete() {
              if (!handlingNext) {
                observer.complete();
              }

              _complete = true;
            }
          });
        });
      }
    }]);

    return ComputedLink;
  }(ApolloLink);

  return new ComputedLink();
}
import _mergeResolvers from './merge-resolvers';
export { _mergeResolvers as mergeResolvers };